export default {
  menu: {
    home: "Dashboard",
    system: "Manage System",
    systemUser: "Manage User",
    systemUserAdd: "User Add",
    systemRole: "Manage Role",
    systemRoleAdd: "Role Add",
    systemDepartment: "Manage Department",
    systemDepartmentAdd: "Department Add",
    systemPost: "Mange Job",
    systemPostAdd: "Job Add",
    systemMenu: "Manage Menu",
    systemMenuAdd: "Menu Add",
    systemMenuEdit: "Menu Edit",
    systemMenuRemove: "Menu Remove",
    product: "Product",
    productStock: "Stock",
    productOffice: "Office",
    order: "Order",
    orderPredict: "Predict",
    orderSale: "Sale",
    orderPurchase: "Purchase",
    orderStockInput: "Stock Input",
    orderStockInputAdd: "Stock Input Add",
    orderStockInputEdit: "Stock Input Edit",
    orderStockOut: "Stock Out",
    orderStockOutAdd: "Stock Out Add",
    orderStockOutEdit: "Stock Out Edit",
    review: "Audit",
    reviewProcess: "Audit",
    reviewPredict: "Audit",
    reviewStockOut: "Audit",
    reviewPurchase: "Audit",
    log: "Log",
    logLogin: "Log",
    logBehavior: "Log",
    orderPredictLog: "Log",
    orderPurchaseLog: "Log",
    orderSaleLog: "Log",
    analysis: "Analysis",
    demo: "Demo",
    demoPage: "Page",
    demoIcon: "Icon",
    demoIconIfy: "Iconify",
    demoAnimaCss: "Animation",
    demoXlsx: "Xlsx",
    demoMap: "CV Drag Scale",
    demoMapOne: "CV Map Division",
    demoMapTwo: "CV Drag",
    demoBrowser: "Browser",
    demoEchart: "Echart",
    demoSwiper: "Swiper",
    demoWifi: "Wifi-Card",
    demoTimeSelect: "Time Select",
    demoLottery: "Lottery",
    demoActivity: "Activity",
    demoImg: "Img Type Change",
    demoThree: "ThreeJS",
    demoPdf: "PDF",
    demoDraggable: "Draggable",
    testLink: "Link",
    testIframe: "Iframe",
  },
  title: {
    home: "Dashboard",
    login: "Login",
    register: "Register",
    auth: "Auth",
    noPower: "No Power",
    notFound: "Not Found",
    serverError: "Server Error",
  },
  msg: {
    copy: "copy success",
  },
  dateTime: {
    week: "Last Week",
    month: "Last Month",
    monthThree: "Last Three Month",
  },
};
